import {Injectable} from '@angular/core';
import {MenuController, ModalController, NavController} from '@ionic/angular/standalone';
import {AuthenticationApiService, UserProfileApiService} from 'src/app/api/services';
import {StorageService} from 'src/app/core/services/storage.service';
import {StorageEnums} from 'src/shared/models/enums';
import {environment} from "../../../environments/environment";
import {AuthService} from "../../../app/core/auth/auth.service";
import {CustomSpinnerService} from "./custom-spinner.service";
import {ApiConfiguration} from "../../../app/api/api-configuration";
import {Router} from "@angular/router";
import {AppConfig} from "../../../app/config/routes.config";
import { EventsService } from './events.service';
import { HelperService } from './helper.service';

@Injectable({
	providedIn: 'root'
})

export class AuthHelperService {

	private routes = AppConfig.routes;

	constructor(private storage: StorageService,
				private menuCtrl: MenuController,
				private navCtrl: NavController,
				private authService: AuthService,
				private AuthenticationApiService: AuthenticationApiService,
				private profileUserService: UserProfileApiService,
				private loader: CustomSpinnerService,
				private apiConfiguration: ApiConfiguration,
				private helperService: HelperService,
				private eventsService: EventsService,
				private modalCtrl: ModalController,
				private router: Router) {
	}


	async whereToRedirect() {
		const returnUrlFromStorage = await this.storage.getItem(StorageEnums.RETURN_URL);
		// this.userSyncService.syncUserData().subscribe();
		
		if (returnUrlFromStorage) {
			this.navCtrl.navigateRoot(returnUrlFromStorage,
				{
					animated: true,
					animationDirection: 'forward'
				}).then(async () => {
				await this.storage.removeItem(StorageEnums.RETURN_URL);
			});
		} else {
			this.navCtrl.navigateRoot('/', {
				animated: true,
				animationDirection: 'forward'
			});
		}
	}

	async logout(e, p) {
		if (p.title === 'sidebar.logout') {
			await this.menuCtrl.close();
			this.modalCtrl.getTop().then(async t => {
				if (t) {
					await t.dismiss();
				}
			});
			this.profileUserService.getUserProfile()
				.subscribe(async profile => {
					await this.storage.setItem(StorageEnums.IsSignInInSocial, 'no');
					await this.storage.removeItem(StorageEnums.WasPAndTShownFromHomePage);
					await this.storage.removeItem(StorageEnums.IsStage);
					this.eventsService.updateProfile(profile);
					e.preventDefault();
					this.authService.updateAuth(false);
					this.AuthenticationApiService.logout1().subscribe(async r => {
						await this.storage.clearOnLogout();
						await this.loader.hide();
						this.apiConfiguration.rootUrl = !document.location.origin.includes('localhost') ? document.location.origin: environment.api;
						await this.storage.setItem(StorageEnums.ApiUrl, (!document.location.origin.includes('localhost') ? document.location.origin: environment.api));
						await this.router.navigate([this.routes.home.fullPath]);
						try {	
							if(profile?.account?.provider === 'swisspass') {
								this.helperService.swissPassLogout();
							}
						} catch (error) { }
					});
				});
		} else {
			await this.router.navigate([p.url], {replaceUrl: true});
		}
	}

}
